/* eslint-disable arrow-body-style */
import React from 'react';
import { useSelector } from 'react-redux';

import { Icon } from '@m12s/component-library';
import { fileAlt, pencil } from 'lib/icons';
import { getWorkOrderId } from 'lib/selectors/getWorkOrderId';
import { getShouldShowWorkOrderIdField } from 'lib/selectors/getShouldShowWorkOrderIdField';
import { useIsWorkOrderFlow } from 'lib/hooks/useIsWorkOrderFlow';

import { useTranslation } from 'react-i18next';
import Routes from 'lib/utils/routes';
import { getMachine } from 'lib/selectors/getMachine';
import { useHistory } from 'react-router-dom';
import { getIsJobLaborTrackingEnabled } from 'lib/selectors/getIsJobLaborTrackingEnabled';
import {
  WorkOrderInfoGroupContainer,
  WorkOrderText,
  HeaderAuxiliaryButton,
  NoWorkOrderIdContainer,
} from './styled';

const WorkOrderInfoGroup = ({ variant, onClickToOverview, isPaused }) => {
  const { t } = useTranslation();

  const workOrderFlowEnabled = useIsWorkOrderFlow();
  const isJobLaborTrackingEnabled = useSelector(getIsJobLaborTrackingEnabled);

  const workOrderId = useSelector(getWorkOrderId);
  const shouldShowWorkOrderIdField = useSelector(getShouldShowWorkOrderIdField);

  const history = useHistory();
  const machine = useSelector(getMachine);

  return (
    <WorkOrderInfoGroupContainer variant={variant} workOrderId={workOrderId}>
      {workOrderId && (
        <>
          <HeaderAuxiliaryButton
            type="button"
            id="view-job"
            variant="auxiliary"
            headerVariant={variant}
            onClick={onClickToOverview}
          >
            <Icon
              icon={fileAlt}
              size="0.625rem"
              style={{ flexShrink: 0, color: 'currentColor' }}
            />
            {t('View Job')}
          </HeaderAuxiliaryButton>
          {shouldShowWorkOrderIdField && (
            <WorkOrderText
              useHeaderBG={false}
              variant={variant}
              isPaused={isPaused}
            >
              {workOrderId}
            </WorkOrderText>
          )}
        </>
      )}

      {!isJobLaborTrackingEnabled &&
        !workOrderFlowEnabled &&
        !workOrderId &&
        shouldShowWorkOrderIdField && (
          <NoWorkOrderIdContainer
            onClick={(e) => {
              e.stopPropagation();
              if (workOrderFlowEnabled) {
                return history.push(
                  `${Routes.machineIdSelectJobPath(
                    machine.id
                  )}?updateWorkOrderId=true`
                );
              }
              return onClickToOverview();
            }}
            variant={variant}
          >
            <Icon
              icon={pencil}
              size="0.6875rem"
              style={{ flexShrink: 0, color: 'currentColor' }}
            />
            <WorkOrderText
              isPaused={false} // this text should be opaque
              useHeaderBG
              variant={variant}
            >
              {t('Add Production Order')}
            </WorkOrderText>
          </NoWorkOrderIdContainer>
        )}

      {!workOrderId && !shouldShowWorkOrderIdField && (
        <HeaderAuxiliaryButton
          type="button"
          id="view-job-only"
          variant="auxiliary"
          headerVariant={variant}
          onClick={onClickToOverview}
        >
          <Icon
            icon={fileAlt}
            size="0.625rem"
            style={{ flexShrink: 0, color: 'currentColor' }}
          />
          {t('View Job')}
        </HeaderAuxiliaryButton>
      )}
    </WorkOrderInfoGroupContainer>
  );
};

export { WorkOrderInfoGroup };
